import { HttpClient } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-tutorials',
  imports: [MatProgressSpinnerModule],
  templateUrl: './tutorials.component.html',
  styleUrl: './tutorials.component.scss',
})
export class TutorialsComponent {
  content: SafeHtml | undefined;
  loading = false;

  private readonly http = inject(HttpClient);
  private readonly sanitizer = inject(DomSanitizer);

  ngOnInit() {
    this.loading = true;
    this.http.get('/knowledge-center/how-to-tutorial-videos', { responseType: 'text' }).subscribe((res) => {
      // Extrahiere den Content aus dem HTML-String
      const parser = new DOMParser();
      const doc = parser.parseFromString(res, 'text/html');
      const content = doc.querySelector('#dnn_ContentPane')?.innerHTML || '';
      this.content = this.sanitizer.bypassSecurityTrustHtml(content);
      this.loading = false;
    });
  }
}
